import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, KeyRound, CalendarDays } from "lucide-react";

export const HomeHero = () => (
  <section className="relative overflow-hidden" data-testid="home-hero">
    <img src="/hero-piazza.jpg" alt="" aria-hidden="true" data-testid="hero-image" className="absolute inset-0 w-full h-full object-cover"/>
    <div className="absolute inset-0 bg-[#091F42]/55"/>
    <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-[#091F42]/80 to-transparent"/>
    <div className="relative max-w-5xl mx-auto px-6 pt-20 pb-36 md:pt-28 md:pb-44 text-center text-white fade-in">
      <span className="chip-gold !bg-[#091F42]/50 mb-6" data-testid="hero-badge">Portale Istituzionale</span>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.08] break-words drop-shadow-[0_4px_18px_rgba(0,0,0,0.45)]" data-testid="hero-title">
        Dove la Pubblica Amministrazione<br className="hidden sm:block"/> incontra gli <span className="text-gold-grad">Artisti.</span>
      </h1>
      <p className="mt-6 max-w-2xl mx-auto text-base md:text-lg text-white/90 leading-relaxed drop-shadow" data-testid="hero-subtitle">
        Un marketplace B2G/B2B/B2C per Comuni, Pro Loco, Enti e Imprese: scopri artisti, fornitori di servizi e genera preventivi conformi alla fatturazione elettronica in pochi click.
      </p>
      <Link to="/registrati" data-testid="hero-try-free" className="mt-8 inline-flex items-center gap-2 font-display text-xl font-bold text-gold hover:text-white transition-colors group">
        Provalo gratis <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform"/>
      </Link>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link to="/chiavi-in-mano" data-testid="hero-turnkey" className="btn-pill-gold"><KeyRound className="w-4 h-4"/>Evento Chiavi in Mano</Link>
        <Link to="/eventi" data-testid="hero-events" className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-white/60 text-white font-semibold hover:bg-white hover:text-[#0D2B5A] transition-colors"><CalendarDays className="w-4 h-4"/>Eventi in Italia</Link>
      </div>
    </div>
  </section>
);
